<template>
  <div class="medicamento-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form>
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12">
            <v-textarea
              v-model="fields.medicamentos"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Medicamentos')"
            />
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { updateData } from "@/services";
export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm },
  data: () => ({
    fields: {
      medicamentos: "",
    },
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };
      this.fields.medicamentos = this.$options.filters.toPT_BRCapitalize(
        this.fields.medicamentos
      );
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);
  },
  methods: {
    onSave() {
      updateData(this, "pet", this.fields);
    },
  },
};
</script>

<style scoped></style>
